import React from 'react'

import styled, {css} from 'styled-components'

const HoverButtonWrapper = styled.button`
  color: ${props=> props.textTerciary};
  text-align: left;
  padding: 19px
  
  :hover {
    color: ${props=> props.brandDefault};
  }
  ${props => props.active && css`
    color: ${props.brandDefault};
  `}
`
export function HoverButton({campaign, ...rest}) {
  return (
    <HoverButtonWrapper 
      {...extractCampaignInfo(campaign)}
      {...rest}
    />
  )
}

//utility function to capture campaing information
const extractCampaignInfo = (campaign) => {
  const colors = campaign.template && campaign.template.appearence && campaign.template.appearence.colors
  return {
    brandDefault: colors && colors["brand-default"],
    brandHover: colors && colors["brand-hover"],
    brandPressed: colors && colors["brand-pressed"],
    brandLight: colors && colors["brand-light"],
    textPrimary: colors && colors["text-primary"],
    textSecondary: colors && colors["text-secondary"],
    textTerciary: colors && colors["text-tertiary"],
  }
}
